import React from "react";
import EmployeeForm from "./EmployeeForm";

const Create = () => {
    return <EmployeeForm mode="create" />;
};

export default Create;